import { NgModule } from '@angular/core';
import { ImpressionEtiquetteModule } from './datamatrix/impression-etiquette.module';
import { LibSiriusNgComponent } from './lib-sirius-ng.component';
import { ImpressionEtiquetteTemplateModule } from './datamatrix/impression-etiquette-template/impression-etiquette-template.module';
import { ListeDocumentsModule } from './datamatrix/impression-etiquette-template/liste-documents/liste-documents.module';
import { DocumentModule } from './datamatrix/impression-etiquette-template/liste-documents/document/document.module';


@NgModule({
  declarations: [LibSiriusNgComponent],
  imports: [
  ],
  exports: [
    LibSiriusNgComponent,
    ImpressionEtiquetteModule,
    ImpressionEtiquetteTemplateModule,
    ListeDocumentsModule,
    DocumentModule
  ]
})
export class LibSiriusNgModule { }
